import React from "react";
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Button
} from "reactstrap";
import { useNavigate } from "react-router-dom";

function AccessDenied({ 
  title = "Access Denied", 
  message = "You don't have permission to access this module.",
  showBackButton = true 
}) {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/admin/home');
  };

  return (
    <Container className="mt-7 pb-5">
      <Row className="justify-content-center">
        <Col lg="6" md="8">
          <Card className="shadow border-0">
            <CardBody className="px-lg-5 py-lg-5 text-center">
              <div className="mb-4">
                <i 
                  className="ni ni-lock-circle-open" 
                  style={{ 
                    fontSize: '4rem', 
                    color: '#f5365c' 
                  }}
                />
              </div>
              
              <h2 className="mb-3" style={{ color: '#32325d' }}>
                {title}
              </h2>
              
              <p className="text-muted mb-4" style={{ fontSize: '1.1rem' }}>
                {message}
              </p>
              
              <div className="text-muted mb-4" style={{ fontSize: '0.9rem' }}>
                <p>This module requires:</p>
                <ul className="list-unstyled">
                  <li>• SUPERADMIN role or higher</li>
                  <li>• Client access to HRMS module</li>
                </ul>
              </div>

              {showBackButton && (
                <Button
                  color="primary"
                  onClick={handleGoBack}
                  className="mt-3"
                >
                  <i className="ni ni-bold-left mr-2" />
                  Back to Dashboard
                </Button>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default AccessDenied;
